import axios from "axios";
import Config from "../Config";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import { getFromLocalStorage } from "../libs/helpers/localstorage";

export const searchAutocompleteApi = async ({ headers, key }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/search?key=${key}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const searchCompaniesApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  if (data.creation_year) {
    if (Array.isArray(data.creation_year)) {
      data.creation_year = data.creation_year.map((y) => parseInt(y, 10));
    } else {
      data.creation_year = parseInt(data.creation_year, 10);
    }
  }
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/company`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

let abortController;

export const searchContactsApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;

  if (data.company_filters?.creation_year) {
    if (Array.isArray(data.company_filters.creation_year)) {
      data.company_filters.creation_year = data.company_filters.creation_year.map((y) => parseInt(y, 10));
    } else {
      data.company_filters.creation_year = parseInt(data.company_filters.creation_year, 10);
    }
  }
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();

  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/contact`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
        signal: abortController.signal,
      },
    );
    return res.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      return { canceled: true };
    }
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const searchBrandsApi = async ({ headers, params = "" }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.brand.list}${params}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const searchPitchesApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/pitch`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const searchWorkRelationApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/clc`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getSavedSearchList = async ({ headers, params = "" }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.savedSearch.api}?${params}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getSingleSavedSearch = async ({ headers, id }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.savedSearch.api}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const createSearch = async ({ headers, body }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.post(
      `${Config.apiBaseurl}/${Config.apis.savedSearch.api}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const deleteSearch = async ({ headers, id }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    await axios.delete(
      `${Config.apiBaseurl}/${Config.apis.savedSearch.api}/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getPlaceListApi = async ({
  headers,
  type,
  isContactsList = false,
}) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/${
        isContactsList ? "contact" : "company"
      }/${type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    }
    throw e;
  }
};

export const getValuesApi = async ({ headers, entity, field }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  try {
    const res = await axios.get(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/${entity}/${field}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );
    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};
